import React, { useMemo } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { formatNumber } from '~/utils/helpers'
import { MilkProductionField } from '../style'
import InfoPopup from '~/components/InfoPopup'
import WarningIcon from '../WarningIcon'
import ErrorIcon from '../ErrorIcon'

const MilkProduction: React.FC = () => {
  const { t } = useTranslation()
  const { control, setError, clearErrors } = useFormContext()

  const watchCowsNumber = useWatch({ control, name: 'cowsNumber' })
  const watchNaturalMilkAMount = useWatch({ control, name: 'naturalMilkAmount' })

  const milkYealdValue = useMemo(() => {
    const naturalMilk = parseInt(watchNaturalMilkAMount || 0)
    const transformedCowsNumber = watchCowsNumber?.toString()?.replace(',', '.')
    const milkYealdValue = transformedCowsNumber > 0 && !isNaN(transformedCowsNumber) ? Math.floor(naturalMilk / transformedCowsNumber) : 0

    if (milkYealdValue && (milkYealdValue < 1000 || milkYealdValue > 20000)) {
      setError('milkProductionYeald', { message: 'Die Milchleistung pro Kuh und Jahr muss mindestens 3.000 kg und kann maximal 20.000 kg betragen.' })
    } else {
      clearErrors('milkProductionYeald')
    }

    return milkYealdValue
  }, [watchNaturalMilkAMount, watchCowsNumber])

  return <>
    <MilkProductionField>
      <label style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
        <div>{t('Milk yield')}</div>
        <InfoPopup
          content={'Automatische Berechnung aus naturaler Milchmenge und  ⌀-Bestand.'}
          styleIcon={{ fontSize: '1.2em' }}
          position={'top center'}
        />
        {(milkYealdValue < 5000 || milkYealdValue > 15000) && <WarningIcon
          control={control}
          name='milkProductionYeald'
          valueField={milkYealdValue}
          content={'Ihre berechnete Milchleistung liegt außerhalb der normalen Bereiche von mind. 6.000kg und maximal 15.000kg pro Kuh und Jahr.'}
        />}
        <ErrorIcon
          control={control}
          name={'milkProductionYeald'}
        />
      </label>
      <div>{`${formatNumber(milkYealdValue, 0)} kg pro Kuh u. Jahr`}</div>
    </MilkProductionField>
  </>
}
export default MilkProduction